import { Locale } from "../../modules/locale";

Locale.getInstance().registerKeySet("fr", " ", {
  fieldLabels: {
    name: "Nom",
    email: "Courriel",
    phone: "Téléphone",
    message: "Écrivez toute info complémentaire… (facultatif)",
    attach: "Ajouter un document",
    fileType: "*.doc, .docx, .pdf (taille maximale du fichier: 5 MB)",
    uploadFileDescription: "Déposez votre CV (obligatoire) et votre lettre de motivation (facultative).",
  },
  errors: {
    name: "Le nom est requis",
    email: "Le courriel est requis",
    phone: "Le téléphone est requis",
    invalidEmail: "Courriel invalide",
    invalidPhone: "Téléphone invalide",
    file: "Veuillez télécharger un fichier",
    fileCount: "Maximum de 2 fichiers autorisés",
    fileType: "Veuillez télécharger un fichier .doc, .docx ou .pdf",
    fileSize: "La taille du fichier dépasse la limite de 5 MB",
    formSubmitError: "Une erreur s'est produite lors de la soumission du formulaire, veuillez réessayer.",
  },
  heading: "Remplissez le formulaire pour soumettre votre candidature pour ce poste.",
  submit: "Postuler",
  successMessage: "Merci d'avoir soumis votre CV!",
});

Locale.getInstance().registerKeySet("en", "cvFileUpload", {
  fieldLabels: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    message: "Write any additional info… (optional)",
    attach: "Attach File(s)",
    fileType: "*.doc, .docx, .pdf (maximum file size: 5 MB)",
    uploadFileDescription: "Upload your CV (required) and cover letter (optional).",
  },
  errors: {
    name: "Name is required",
    email: "Email is required",
    phone: "Phone is required",
    invalidEmail: "Invalid email",
    invalidPhone: "Invalid phone",
    file: "Add a document",
    fileCount: "Maximum of 2 files allowed",
    fileType: "Please upload a .doc, .docx, or .pdf file",
    fileSize: "File size exceeds 5 MB limit",
    formSubmitError: "An error occurred submitting the form, please try again.",
  },
  heading: "Complete the form to submit your application for this position.",
  submit: "Apply",
  successMessage: "Thank you for submitting your CV!",
});